import script from "./webLayout.vue?vue&type=script&lang=ts&setup=true"
export * from "./webLayout.vue?vue&type=script&lang=ts&setup=true"

import "./webLayout.vue?vue&type=style&index=0&id=2cdc4b16&scoped=true&lang=less"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2cdc4b16"]])

export default __exports__